import { $display } from './context.js'

/* global Swiper */

/** @type {import('swiper').default | null} */
let variantSwiper = null

/** @type {import('swiper').default | null} */
let detailSwiper = null

/**
 * Recoge el id solicitado via ?v= (o el estado del filtro activo).
 * @returns {string}
 */
const requestedVariant = () => {
    const fromQuery = new URLSearchParams(window.location.search).get('v')
    return fromQuery || ($display.attr('data-variant') || '')
}

/**
 * Sincroniza el atributo data-variant del área de producto con la variante
 * solicitada en la URL (?v=), evitando heredar la variante del producto anterior.
 * @param {string} url
 */
export const syncRequestedVariant = (url) => {
    const variantParam = new URL(url).searchParams.get('v')
    $display.attr('data-variant', variantParam || '')
}

/**
 * Ejecuta slideTo usando el slide cuya data-variant-id coincide.
 * @param {import('swiper').default} swiper
 * @param {string} id
 * @param {number} speed
 */
const slideToVariant = (swiper, id, speed) => {
    const index = swiper.slides.findIndex(
        (slide) => slide.getAttribute('data-variant-id') === id
    )
    if (index > -1) swiper.slideTo(index, speed)
}

/**
 * Inicializa (o reinicializa) los swipers internos del área de producto.
 */
export const initContentSwipers = () => {
    variantSwiper?.destroy(true, true)
    detailSwiper?.destroy(true, true)
    variantSwiper = null
    detailSwiper = null

    if (!$display.find('.detail-swiper')) return

    const current = requestedVariant()
    const thumbsSlides = Array.from(document.querySelectorAll('#product-display-area .variant-swiper .swiper-slide'))
    const activeThumb = current
        ? thumbsSlides.find((slide) => slide.getAttribute('data-variant-id') === current)
        : null
    const initial = activeThumb ? thumbsSlides.indexOf(activeThumb) : 0

    if ($display.find('.variant-swiper')) {
        variantSwiper = new Swiper('#product-display-area .variant-swiper', {
            slidesPerView: 'auto',
            spaceBetween: 12,
            watchSlidesProgress: true
        })
    }

    const detailConfig = {
        spaceBetween: 16,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        initialSlide: initial,
        navigation: {
            nextEl: '#product-display-area .swiper-button-next',
            prevEl: '#product-display-area .swiper-button-prev'
        }
    }

    if (variantSwiper) {
        detailConfig.thumbs = {
            swiper: variantSwiper,
            slideThumbActiveClass: 'swiper-slide-thumb-active'
        }
    }

    detailSwiper = new Swiper('#product-display-area .detail-swiper', detailConfig)
}

/**
 * Selecciona una variante deslizando la cinta de thumbs y el detalle.
 * @param {string} id
 * @param {number} speed
 */
export const selectVariant = (id, speed) => {
    if (!variantSwiper) return
    slideToVariant(variantSwiper, id, speed)
    if (detailSwiper) slideToVariant(detailSwiper, id, speed)
}
